import React, { Component } from 'react';
import { MDBIcon, MDBInput } from 'mdbreact';
import Swal from 'sweetalert2';
import { withRouter } from "react-router-dom";
import { LoginValidarTalentoHumano } from '../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../config/URLDB';

const validate = values => {
    const errors = {}
    const requiredFields = {
        usuario: "Digita tu usuario",
        clave: "Digita tu contraseña"
    }
    for (const field in requiredFields) {
        if (!values[field] || values[field].trim() === "") {
            errors[field] = requiredFields[field]
        }
    }
    return errors;
}

class LoginTalentoHumano extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            usuario: '',
            clave: ''
        };
    }
    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    textInputUser = (e) => {
        var mayus = e.target.value.toUpperCase();
        this.setState({
            usuario: mayus
        })
    }

    validarLogin = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            const data = {
                usuario: this.state.usuario,
                clave: this.state.clave
            }

            LoginValidarTalentoHumano(data).then(response => {
                try {
                    const dataRes = response?.data || [];
                    if (dataRes.length > 0) {
                        if (dataRes[0].message !== "000000") {
                            Swal.fire({
                                icon: 'warning',
                                title: dataRes[0].descMessage
                            })
                        } else {
                            sessionStorage.setItem('idusuariotalentoh', dataRes[0].id);
                            sessionStorage.setItem('usuariotalentoh', this.state.usuario);
                            this.setState({
                                usuario: '',
                                clave: ''
                            });
                            this.props.history.push('/admin/talentoHumano/principal')
                        }
                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: dataRes.descMessage
                        })
                    }
                } catch (error) {
                    this.setState({ clave: '' });
                    Swal.fire({
                        icon: 'error',
                        /*title: response.data[0].descMessage, --> Si hay un error en el consumo, 'response' podría no existir*/ 
                        title: 'Error inesperado al iniciar sesión'
                    });
                }
            });
        }
    }

    render() {
        const { errors } = this.state;
        return (
            <React.Fragment>
                <div className="login_admin">
                    <div className="card py-3 px-3 contenedor_campos">
                        <div className="card-body text-center">
                            <div className="contenido">
                                <img className="img-fluid" src={`${URLImgFront}/assets/logo/utrahuilca-logo.svg`} alt="img-logo" />
                            </div>
                            <div>
                                <div className="pb-1 pt-5">
                                    <MDBInput
                                        name="usuario"
                                        className="mt-0 text-postulate"
                                        label="Digita tu usuario"
                                        type="text"
                                        value={this.state.usuario}
                                        onChange={this.textInputUser}
                                    />
                                    {errors.usuario && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-35px', left: '35px' }}>{errors.usuario}</strong>}
                                </div>
                                <div>
                                    <MDBInput
                                        name="clave"
                                        className="mt-0 text-postulate"
                                        label="Digita tu contraseña"
                                        type="password"
                                        value={this.state.clave}
                                        onChange={this.textInput}
                                    />
                                    {errors.clave && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-35px', left: '35px' }}>{errors.clave}</strong>}
                                </div>
                                <div className="text-center">
                                    <button
                                        className="btn"
                                        onClick={this.validarLogin}
                                        style={{ background: '#FA7400', color: 'white', fontWeight: 'bold' }}
                                    >
                                        Ingresar
                                        <MDBIcon icon="sign-in-alt" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default withRouter(LoginTalentoHumano);